export default function ({app, error}) {
  if (!app.$planHasPermission('download_document_template')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}